// Executive Mat Mock Data
// This file contains all mock data that will later be replaced with backend API calls

export const COMPANY_INFO = {
  name: "Executive Mat",
  tagline: "Safety • Health • Environment",
  logo: process.env.REACT_APP_LOGO_URL || "/images/logo.png",
  serviceAgreementPdf: process.env.REACT_APP_SERVICE_AGREEMENT_PDF_URL || ""
};

// Mat sizes and base pricing (Every 4 Weeks - E4W)
export const MAT_PRODUCTS = [
  {
    id: "3x5",
    name: "3×5 Executive Mat",
    dimensions: "3' × 5'",
    priceE4W: 9.93,
    description: "Ideal for single doors and smaller entrances"
  },
  {
    id: "4x6",
    name: "4×6 Executive Mat",
    dimensions: "4' × 6'",
    priceE4W: 15.89,
    description: "Perfect for standard commercial entrances"
  },
  {
    id: "3x10",
    name: "3×10 Executive Mat",
    dimensions: "3' × 10'",
    priceE4W: 19.87,
    description: "Best for high-traffic or wide entrances"
  }
];

// Agreement terms with discounts
export const AGREEMENT_TERMS = [
  { months: 12, discount: 0, label: "12 Months", description: "Standard term" },
  { months: 36, discount: 0.07, label: "36 Months", description: "7% discount" },
  { months: 60, discount: 0.15, label: "60 Months", description: "15% discount" }
];

// Service charges
export const SERVICE_CHARGES = {
  defCharge: 0.09, // 9% DEF service charge
  greenCharge: 0.12, // 12% Green charge
  minimumInvoice: 40 // $40 minimum invoice
};

// Service info
export const SERVICE_INFO = {
  billingFrequency: "Every 4 weeks",
  serviceFrequency: "Every 8 weeks",
  responseTime: "1 business day"
};

// Value proposition tiles
export const VALUE_TILES = [
  {
    id: "better-product",
    title: "Better Product",
    subtitle: "Featuring Weather Stopper™",
    points: [
      "Exclusive 'Water Dam' border traps 3× more moisture",
      "Enhanced scraping and absorption",
      "More consistent appearance between changes"
    ],
    icon: "Shield"
  },
  {
    id: "lower-cost",
    title: "Lower Annual Cost",
    subtitle: "Not teaser weekly pricing",
    points: [
      "Lower total cost over the year",
      "Right-sized mat program (sizes, placement, frequency)",
      "Fewer replacements and fewer service issues"
    ],
    icon: "TrendingDown"
  },
  {
    id: "carbon-neutral",
    title: "Carbon Neutral",
    subtitle: "Sustainable choice",
    points: [
      "Carbon-neutral mat program option",
      "Supports sustainability reporting and internal goals",
      "Documentation available on request"
    ],
    icon: "Leaf"
  },
  {
    id: "canadian-business",
    title: "Canadian Family Business",
    subtitle: "Trusted partnership",
    points: [
      "Canadian owned and operated",
      "Fast, accountable service decisions",
      "Long-term partnerships over short-term contracts"
    ],
    icon: "MapPin"
  }
];

// Custom quote options
export const CUSTOM_QUOTE_NEEDS = [
  { id: "5plus", label: "5 or more mats" },
  { id: "custom-sizes", label: "Custom sizes" },
  { id: "colors", label: "Different colours" },
  { id: "logo", label: "Logo mats" },
  { id: "multiple-entrances", label: "Multiple entrances" },
  { id: "high-traffic", label: "High-traffic locations" }
];

// Helper function to calculate pricing
export const calculatePricing = (cartItems, termMonths) => {
  const term = AGREEMENT_TERMS.find(t => t.months === termMonths) || AGREEMENT_TERMS[0];
  const discount = term.discount;
  
  // Calculate base subtotal (E4W pricing)
  // Use price_e4w from cart item (backend data) or fall back to MAT_PRODUCTS lookup
  let subtotal = 0;
  cartItems.forEach(item => {
    if (item.price_e4w) {
      // Use price from cart item (backend data)
      subtotal += item.price_e4w * item.quantity;
    } else {
      // Fall back to mock data lookup
      const product = MAT_PRODUCTS.find(p => p.id === item.id);
      if (product) {
        subtotal += product.priceE4W * item.quantity;
      }
    }
  });
  
  // Apply term discount
  const discountedSubtotal = subtotal * (1 - discount);
  
  // Calculate charges
  const defCharge = discountedSubtotal * SERVICE_CHARGES.defCharge;
  const greenCharge = discountedSubtotal * SERVICE_CHARGES.greenCharge;
  
  // Total before minimum check
  let total = discountedSubtotal + defCharge + greenCharge;
  
  // Check minimum invoice
  const minimumApplies = total < SERVICE_CHARGES.minimumInvoice && total > 0;
  if (minimumApplies) {
    total = SERVICE_CHARGES.minimumInvoice;
  }
  
  // Calculate weekly equivalent (E4W / 4)
  const weeklyEquivalent = total / 4;
  
  // Calculate savings from discount
  const savings = subtotal * discount;
  
  return {
    subtotal: discountedSubtotal,
    defCharge,
    greenCharge,
    total,
    weeklyEquivalent,
    minimumApplies,
    savings,
    discount: discount * 100
  };
};

// Get total mat count
export const getTotalMatCount = (cartItems) => {
  return cartItems.reduce((sum, item) => sum + item.quantity, 0);
};
